import Container from "../../../components/container";
import line from "../../../assets/images/section2_line.svg";
import img_section2 from "../../../assets/images/section2_image.svg";
// import baner2 from "../../../assets/images/section2_baner2.svg";
import baner from "../../../assets/images/approach_baner.png";

export default function Section4() {
   return (
      <section className="section2"
      >
         <div className="relative w-full">
            <div className="absolute h-[600px] top-0 right-0 bg-[#CBEBFF] w-1/2 -z-10 hidden lg:block"></div>
            <Container className="!px-0 sm:!px-[30px] lg:pl-[40px] lg:!pr-0 2xl:!px-0">
               <div className="flex w-full bg-[#CBEBFF] lg:h-[600px] lg:rounded-tl-[351px] lg:rounded-bl-[351px] rounded-bl-[500px] rounded-br-[500px]">
                  <div className="flex w-full justify-center lg:justify-between">
                     <div className="hidden lg:block relative overflow-hidden lg:w-[412px] 2xl:w-[460px] h-[600px] rounded-tl-[351px] rounded-bl-[351px]">
                        <div className="absolute w-[361px] h-[388px] lg:right-[-16px] 2xl:w-[460px] 2xl:h-[469px] lg:top-[141px] 2xl:top-[65px] 2xl:left-[-23px]">
                           <img src={baner} alt="img_section2" className="w-[361px] h-[388px] 2xl:w-[460px] 2xl:h-[469px]" style={{ objectFit: 'contain' }} />
                        </div>
                     </div>

                     <div className="flex flex-col w-full md:w-[660px] ">
                        <div className="flex items-center pt-[66px] mb-[66px] px-[30px] md:px-0">
                           <h3 className="text-[#EB4A00] font-bold text-[24px] leading-[30px] md:text-[32px] md:leading-[40px] lg:text-[40px] pr-[10px]">Our approach</h3>
                           <div className="h-[1px]">
                              <img src={line} alt="line" style={{ objectFit: 'contain' }} />
                           </div>
                        </div>
                        <div className="flex flex-col w-full gap-[30px] max-w-[770px] px-[30px] md:px-0">
                           <div className="flex flex-col">
                              <div className="flex items-center gap-[9px]">
                                 <div className="flex items-center justify-center w-[44px] h-[24px] border-[2px] border-[#00B5EA] rounded-[25px]"><div className="bg-[#00B5EA] w-[8px] h-[8px] rounded-full"></div></div>
                                 <span className="text-[#003A75] text-[20px] leading-[30px] lg:text-[24px] lg:leading-[30px] font-bold">Rapid, iterative delivery </span>
                              </div>
                              <p className="text-[14px] lg:text-[15px] leading-[25px] text-[#000] mt-[8px] ">Short cycles, playable builds early, and clear milestones.</p>
                           </div>

                           <div className="flex flex-col">
                              <div className="flex items-center gap-[9px]">
                                 <div className="flex items-center justify-center w-[44px] h-[24px] border-[2px] border-[#00B5EA] rounded-[25px]"><div className="bg-[#00B5EA] w-[8px] h-[8px] rounded-full"></div></div>
                                 <span className="text-[#003A75] text-[20px] leading-[30px] lg:text-[24px] lg:leading-[30px] font-bold">Data-driven decisions</span>
                              </div>
                              <p className="text-[14px] lg:text-[15px] leading-[25px] text-[#000] mt-[8px] ">Telemetry, experiments, and KPIs to guide roadmap and LiveOps.</p>
                           </div>

                           <div className="flex flex-col">
                              <div className="flex items-center gap-[9px]">
                                 <div className="flex items-center justify-center w-[44px] h-[24px] border-[2px] border-[#00B5EA] rounded-[25px]"><div className="bg-[#00B5EA] w-[8px] h-[8px] rounded-full"></div></div>
                                 <span className="text-[#003A75] text-[20px] leading-[30px] lg:text-[24px] lg:leading-[30px] font-bold">Reliable infrastructure</span>
                              </div>
                              <p className="text-[14px] lg:text-[15px] leading-[25px] text-[#000] mt-[8px] ">Cloud-native backends with auto-scaling, CI/CD, and robust monitoring.</p>
                           </div>

                           <div className="flex flex-col">
                              <div className="flex items-center gap-[9px]">
                                 <div className="flex items-center justify-center w-[44px] h-[24px] border-[2px] border-[#00B5EA] rounded-[25px]"><div className="bg-[#00B5EA] w-[8px] h-[8px] rounded-full"></div></div>
                                 <span className="text-[#003A75] text-[20px] leading-[30px] lg:text-[24px] lg:leading-[30px] font-bold">Privacy & compliance</span>
                              </div>
                              <p className="text-[14px] lg:text-[15px] leading-[25px] text-[#000] mt-[8px] ">GDPR/CCPA/COPPA-aware design, secure data handling, and transparent user consent.</p>
                           </div>
                        </div>
                        <div className="lg:hidden block relative overflow-hidden h-[180px] ssm:h-[368px] w-full rounded-bl-[500px] rounded-br-[500px]">
                           <div className="absolute ssm:w-[361px] ssm:h-[388px] transform -translate-x-1/2 left-1/2 top-[21px]">
                              <img src={baner} alt="baner" className="w-full h-full" style={{ objectFit: 'contain' }} />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Container>
         </div>
      </section>);
}